<!--
    描述：组织机构树
    日期：2021/04/22
    作者：zwh
-->
<template>
    <div class="h100">
        <div class="w-page-main" style="padding-top:0px">
            <div class="w-page-container" style="padding : 0px">
                <div class="w-table-layout">
                    <div class="w-table-content" ref="treeContent" style=" overflow-y: auto; border:1px solid #eee">
                        <el-tree ref="tree"
                                 :height="treeObj.height"
                                 :data="treeObj.data"
                                 :props="defaultProps"
                                 :expand-on-click-node="false"
                                 :highlight-current="true"
                                 default-expand-all
                                 show-checkbox
                                 :check-strictly="true"
                                 node-key="id"
                                 @node-click="nodeClick"
                                 @check-change="checkChange"
                        ></el-tree>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getDeptsAndUsers } from 'api/system/sysDept.js'
export default {
    name : '',
    components: {

    },
    data() {
        return {
            defaultProps: {
                children: 'children',
                label: 'sname'
            },
            treeObj: {
                height: 200,
                data: [],
            },
        }
    },
    mounted() {},
    computed: {},
    watch: {},
    created() {
        //获取组织结构及人员信息
        this.getDeptsAndUsers()
    },
    methods: {
        //获取组织结构及人员信息
        getDeptsAndUsers() {
            let that = this
            this.treeObj.data = []
            let param = {

            }
            getDeptsAndUsers(param).then(res=>{
                if(res.operationCode == 1) {
                    this.treeObj.data = res.data
                    this.$emit('org-trans-data', this.treeObj.data)
                }
            })
        },
        //节点点击
        nodeClick(obj) {
            this.$emit('row-click', obj)
        },
        //选中/取消事件
        checkChange(node, isChecked, sonIsChecked){
            node.isChecked = isChecked
            this.$emit('org-trans-data', this.treeObj.data)
        },
    }
}
</script>
<style lang="less">

</style>